import { useState, useEffect } from "react";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

const RadioInput = (props) => {
  const { id, typeName, order, input: { onChange, onBlur }, customValue, checkedOption, setCheckedOption, setCustomValue, fieldType, meta: { touched, error, warning } } = props;
  // const [checkedOption, setCheckedOption] = useState();
  // const [defaultOption, setDefaultOption] = useState();

  // useEffect(() => {
  //   if (checkedOption) {
  //     console.log(20000, checkedOption.value);
  //     changeHandler(checkedOption);
  //   }
  // }, [customValue])

  useEffect(() => {
    if (checkedOption) {
      // onChange(checkedOption);
      onChange({
        id,
        typeName,
        order,
        result: checkedOption
      });
      // Need for validation, otherwise validation function won't be called
      onBlur();
    }
  }, [customValue])

  // useEffect(() => {
  //   // console.log(66666, defaultOption);
  //   console.log(1, defaultOption);
  //   if (defaultOption) {
  //     const newOption = {...defaultOption};
  //     setCheckedOption(newOption);
  //     onChange(newOption);
  //   }
  // }, [defaultOption]);

  // useEffect(() => {
  //   // console.log(66666, defaultOption);
  //   if (!defaultOption) {
  //     if (props?.options?.length > 0) {
  //       const option = props.options.find(option => option.default);
  //       if (option) {
  //         console.log(3, option)
  //         setDefaultOption(option);
  //         setCustomValue(option.value);
  //         setCheckedOption(option)
  //         onChange(option);
  //       }
  //     }
  //   }
  // }, []);

  const changeHandler = (option) => {
    const newOption = { ...option }
    if (newOption?.typeName === 'CUSTOM_OPTION') {
      newOption.value = customValue;
    }
    setCheckedOption(newOption)
    // onChange(newOption);
    onChange({
      id,
      typeName,
      order,
      result: newOption
    });
    // Need for validation, otherwise validation function won't be called
    onBlur();
  };

  // const changeCustomHandler = (event) => {
  //   console.log('Custom input CHANGE');
  //   setCustomValue(event.target.value);
  //   if (checkedOption?.typeName === "CUSTOM_OPTION") {
  //     const newOption = { ...checkedOption }
  //     newOption.value = event.target.value;
  //     setCheckedOption(newOption);
  //   }
  // }

  // const options = props.options.map(option => (
  //   <label key={option.id}>
  //     <input
  //       name={option.name}
  //       type="radio"
  //       checked={option.id === checkedOption?.id}
  //       onChange={() => changeHandler(option)}
  //     />{' '}
  //     {option.label}
  //     {/* {fieldType === 'CUSTOM_OPTION' &&
  //       <Field
  //         name={`${props.name}_custom_option`}
  //         required={props.required}
  //         component="input"
  //         type="text"
  //         placeholder=""
  //         value={customValue}
  //         // defaultValue={value}
  //         onChange={(event) => changeCustomHandler(event)}
  //       />
  //     } */}
  //   </label>
  // ));
  // return options;

  return (
    <div>
      <RadioGroup
        aria-labelledby="demo-controlled-radio-buttons-group"
        name="controlled-radio-buttons-group"
      >
        {props.options.map(option => (
          <FormControlLabel
            key={option.id}
            control={
              <Radio
                checked={option.id === checkedOption?.id}
                onChange={() => changeHandler(option)}
              />
            }
            label={option.label}
          />
        ))}
      </RadioGroup>
      {/* {touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))} */}
    </div>
  );

}

export default RadioInput;